import {
  IInstitution as IAaNgInstitution,
  IPersonsCollaborations,
} from 'aa-ng';

import {
  ICollaborationDetails,
  ICollaborationSummary,
  mapCollaborationSummary,
} from '.';
import { IPerson } from './person';

export interface IPersonCollaborations extends IPerson {
  /** Graph node identity. Numeric person ids span two id spaces and cannot key a graph. */
  guid: string;
  numberOfActivities: number;
  collaborations: ICollaborationSummary[];
  activityIds?: number[];
  collaborationCounts?: { [key: string]: number };
  activities?: ICollaborationDetails[];
  totalCollaborationsCount?: number;
}

export function mapPersonCollaborations(
  personCollaborations: IPersonCollaborations,
): IPersonsCollaborations {
  const { id, primaryUnitAffiliation, primaryInstitution, collaborations } =
    personCollaborations;

  return {
    ...personCollaborations,
    personId: id,
    primaryUnitId: primaryUnitAffiliation?.id,
    primaryUnitName: primaryUnitAffiliation?.name,
    primaryInstitution: primaryInstitution as IAaNgInstitution,
    collaborations: collaborations.map((c) => mapCollaborationSummary(c)),
  } as IPersonsCollaborations;
}
